<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <a-form :form="form" @submit="handleSubmit">
      <a-row class="items">
        <a-col :span="21">
            初始化密码与用户名相同,请在个人中心,修改密码处修改
          <a-form-item label="用户名" :label-col="{ span: 8}" :wrapper-col="{ span:12 }">
            <a-input
              placeholder="请输入用户名"
              v-decorator="[
          'userName',
          {rules: [{ required: true, message: '请输入用户名!' }],initialValue:info.userName}
        ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="21">
        </a-col>
        <a-col :span="21">
          <a-form-item label="所在地区" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-cascader
                    :options="areas"
                    change-on-select
                    placeholder="请选择地区"
                    @change="areaChange"
                    :default-value="areaList"
                    :fieldNames="{ label: 'name', value: 'name', children: 'children' }"
            />
          </a-form-item>
        </a-col>
        <a-col :span="21">
          <a-form-item  label="主管部门" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-select
                    mode="tags"
              placeholder="请选择主管部门"
              v-decorator="[
          'administration',
          {rules: [{ required: false, message: '请选择主管部门!' }],initialValue:info.administration}
        ]"
            >
              <a-select-option
                :value="info.itemName"
                v-for="(info, index) in administrationList"
                :key="index"
              >{{info.itemName}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>


      </a-row>
      <a-form-item :wrapper-col="{ span: 24, offset: 10 }" style="margin-top:20px;">
        <pxkeji-btn name="保存" type="primary" htmlType="submit" />
        <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
      </a-form-item>
    </a-form>
  </a-spin>
</template>

<script>
var that;
export default {
  props: {
    id: String,
    userId: String
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {},
      jobSetList: [],
      titleList: [],
      administrationList: [],
      servicelists: [],
      serviceNames: [],
      serviceIds: [],
      goodlists: [],
      goodNames: [],
      goodIds: [],
      isloading: false,
      loadingTip: "加载中...",
      fileList: [],
      previewVisible: false,
      areas: [],
      areaList: [],
      size: "large",
      service: {
        //服务项目
        visible: false,
      },
      good: {
        //擅长项目
        visible: false,
      },
      schedule: {
        //排班
        visible: false,
        list: "",
      },
    };
  },
  components: {},
  mounted() {
    this.$nextTick(function () {

      that = this;
      if (this.id) {
        //编辑
        this.getInfo();
      }
      if (!this.type) {
        this.dis = true;
      }
      this.getArea();
      this.getDictionaryItem();
    });
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    //获取数据字典
    getDictionaryItem() {
      this.$api.dictionaryItem.tree(23).then((res) => {
        if (res.errorCode == this.$msg.responseCode.success) {
          this.administrationList = res.data;
        } else {
          this.error(res.errorMsg);
        }
      });

    },
    getArea() {
      this.areas = this.$api.city.city;
    },
    areaChange(value) {
      this.info.province = value[0];
      this.info.city = value[1];
      this.info.area = value[2];
      this.info.areaLevel=value.length;
    },
    /**数据回显 */
    getInfo() {
      this.isloading = true;
      this.$api.student
              .getpermissionuser(this.userId)
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data;
            var str =res.data.administration;
            this.info.administration= str.split(',');
            this.areaList.push(this.info.province);
            this.areaList.push(this.info.city);
            this.areaList.push(this.info.area);
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          var data = {
            userName: values.userName,
            province: this.info.province?this.info.province:"",
            city: this.info.city?this.info.city:"",
            area: this.info.area?this.info.area:"",
            administration: values.administration?values.administration.join(","):"",
            areaLevel:this.info.areaLevel?this.info.areaLevel:0
          };
          if (this.id) {
            //修改
            data.id=this.id;
            data.userId=this.userId;
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.student
                    .updatepermissionuser(data)
              .then((res) => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          } else {
            //新增
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.student
              .savepermissionuser(data)
              .then((res) => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                  //this.form.resetFields();
                } else {
                  this.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          }
        }
      });
    },



    onCheckboxChange(e) {
      this.info.checked = e.target.checked;
    },
    handleCancel() {
      this.previewVisible = false;
    },


    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        },
      });
    },
  },
};
</script>
<style>
.scheduleBtn {
  color: #1890ff;
  cursor: pointer;
}

.signup_items {
  border: 1px #ddd solid;
}
.signup_basicinfo {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.signup_hpic {
  width: 140px;
  height: 160px;
  text-align: center;
  line-height: 150px;
  border-left: 1px #ddd solid;
  border-bottom: 1px #ddd solid;
}
.signup_hpic img {
  width: 100%;
  height: 100%;
}
.signup_bsleft {
  flex: 1;
}
.signup_bscol {
  width: 100%;
  display: inline-flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 40px;
  border-bottom: 1px #ccc solid;
}
.signup_bscol > div {
  height: 100%;
  border-right: 1px #ccc solid;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 130px;
  padding: 0 15px;
  box-sizing: border-box;
}
.signup_bscol > div:last-child {
  border: none;
}
.signup_tit {
  text-align: center;
  border-right: 1px #ccc solid;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 130px;
  padding: 0 15px;
  box-sizing: border-box;
}
.signup_bscol > div select,
.signup_bscol > div input {
  height: 30px;
  border: 1px #ddd solid;
  border-radius: 5px;
  padding-left: 10px;
  width: 115px;
}
.extra_info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: row;
}
.extra_info_fl {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border-right: 1px #ccc solid;
  width: 50%;
  border-bottom: 1px #ccc solid;
  height: 40px;
}
.half_in {
  flex: 1;
  padding: 0 15px;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  white-space: normal;
  word-break: keep-all;
}
.rejecttags {
  display: block;
}
.half_in input,
.half_in select {
  flex: 1;
  height: 30px;
  border: 1px #ddd solid;
  border-radius: 5px;
  padding-left: 10px;
}
.extra_info_fr {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  border-bottom: 1px #ddd solid;
}
.extra_info_fr .signup_tit {
  height: 100%;
}
.signup_tra {
  flex: 1;
  border: 1px #ddd solid;
  border-radius: 5px;
}
.extra_info2 {
  height: auto;
}
.extra_info2 > div {
  height: 100%;
}
.con_rt {
  border-left: 1px #ccc solid;
  padding: 10px;
}
.fmbox {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
}
.family_members {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px #ccc solid;
}
.family_members:last-child {
  border-bottom: none;
}
.family_members div {
  width: 25%;
  text-align: center;
  border-right: 1px #ccc solid;
}
.family_members div:last-child {
  border: none;
}
.family_members div input {
  width: 100%;
  text-align: center;
  border: none;
  box-shadow: none;
}
.signup_tit2 {
  border: none;
}
.checkTop {
  border-bottom: 1px #ccc solid;
}
.checkTop .half_in {
  padding: 5px 15px !important;
}
.fixInfo2 {
  border-bottom: 1px #ccc solid;
}
.fixInfo2 .extra_info_fl {
  border-right: 1px #ccc solid;
  border-bottom: none;
}
</style>